<template>
	<el-dialog title="New Message" :visible.sync="showMessage" 
		append-to-body
		width="900px"
		:before-close="handleClose"
		:close-on-click-modal="false"
		class="message-dialog"> 
		<div class="message-wrapper">
			<div class="message-draft">
				<div class="patient-wrapper">
					<span class="patient-to">To</span>
					<div class="patient-list">
						<span v-for="patient in patientList"
							:key="patient.id"
							class="patient">
							{{patient.name}}
							<i class="el-icon-close" @click="$emit('remove-patient', patient.id)"></i>
						</span>
					</div>
				</div>
				<div class="message-edit">
					<h4>Message Text</h4>
					<textarea :maxlength="maxCount" v-model="editMessage" placeholder="Start typing..."></textarea>
					<div class="submit-button">
						<span class="word-count">
							{{ maxCount - editMessage.length }}/{{ maxCount }}
							characters left
						</span>
						<el-button @click="handleClose" type="text" class="cancel-button" >Cancel</el-button>
						<LoadingButton 
							type="primary"
							:disabled="isValidToSend"
							@click="sendMessage"
							:loading="isMessaging"
							:loaded="messageSent">
							Send Message
						</LoadingButton>
					</div>
				</div>
			</div>
			<!-- <div class="message-suggest">
				<div class="suggest-head">Template</div>
				<div class="message-template" :class="{expand: expandIndex === index}" v-for="(message, index) in suggestedMessage" :key="index">
					<div class="message-value">
						{{message.value}}
					</div>
					<div class="message-action">
						<i class="el-icon-arrow-down expand-icon" :class="{ 'expanded-icon': expandIndex === index}" @click="toggleExpand(index)"></i>
						<el-button class="select-button" @click="editMessage = message.value">
							Select Template
						</el-button>
					</div>
				</div>
			</div> -->
		</div>
		<div></div>
	</el-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import LoadingButton from '@/module/component/LoadingButton'

export default {
	name: 'message-dialog',
	props: {
		patientList: {
			type: Array,
			default: () => []
		},
		showMessage: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			editMessage: '',
			suggestedMessage: [
				{
					value: "Looking forward to reviewing your symptoms and other health information. You should form a habit of recording them frequently.Your information informs us about something",
				},
				{
					value: "Just a reminder to record any symptoms you experience and other health information. The information tells us how you are doing at home and helps us plan / adjust the treatment. We will go over these the next time we see you."
				}
			],
			messageSent: false,
			expandIndex: null,
			maxCount: 3000
		}
	},
	methods: {
		...mapActions('provider', [
			'createPatientMessageBulk'
		]),
		handleClose(done) {
			// Default the edit message to blank for closing
			this.editMessage = ''
			this.messageSent = false
			this.$emit('close')
			return
		},
		toggleExpand(index) {
			this.expandIndex = this.expandIndex !== index ? index : null
		},
		/**
		 * Send message to patient list
		 */
		sendMessage() {
			// Message data comprising of patient id's and text message to be sent
			const messageData = {
				patient: this.patientList.map((patient) => patient.id),
				text: this.editMessage
			}
			// Create message action called
			this.createPatientMessageBulk(messageData)
				.then((response) => {
					this.messageSent = true
					// Closing message box after half second of api response complete
					setTimeout(() => this.handleClose(), 0.5 * 1000)
				})
		}
	},

	computed: {
		...mapState('provider', {
			isMessaging: (state) => state.messagingPatientBulk
		}),
		isValidToSend() {
			return this.editMessage.trim() === '' || this.patientList.length === 0
		}

	},

	components: {
		LoadingButton
	}
}
</script>

<style lang="scss" scoped>
@import "@/module/app/theme/dialog.scss";

.message-wrapper{
	display: flex;
	.message-draft{
		width: 100%;
		border-right: 1px solid #cccccc;
		.patient-wrapper {
			display: flex;
		}
		.patient-to{
			height: 160px;
			width: 50px;
			text-align: center;
			padding: 20px 0px;
			border-bottom: 1px solid #cccccc;
		}
		.patient-list{
			display: flex;
			height: 160px;
			overflow-y: scroll;
			border-bottom: 1px solid #cccccc;
			padding-top: 13px;
			flex-grow: 1;
			flex-wrap: wrap;
			align-items: flex-start;
			align-content: flex-start;
			
			.patient{
				height: 25px;
				margin: 0px 6px 8px 2px;
				padding: 0 4px;
				border: 1px solid #cccccc;
				border-radius: 15px;
				display: flex;
				align-items: center;
				.el-icon-close{
					cursor: pointer;
					margin-left: 4px;
				}
			}
		}
		.message-edit{
			height: 400px;
			padding: 12px 20px;
			h4 {
				font-size: 14px;
				line-height: 17px;
				font-weight: normal;
				color: #666666;
				margin-bottom: 10px;
			}
			textarea{
				width: 100%;
				font-size: 14px;
				line-height: 18px;
				outline: none;
				border: none;
				background: transparent;
				resize: none;
				height: 300px;
				word-break: keep-all;
				word-wrap: normal;
			}
			textarea::placeholder {
				color: #999999;
			}
			.submit-button{
				@extend %dialog-action;
				justify-content: flex-start;
				.word-count {
					color: #666666;
					flex-grow: 1;
				}
			}
		}
	}
	.message-suggest{
		width: 25%;
		display: flex;
		flex-direction: column;
		color: #666666;
		.suggest-head{
			padding: 9px 13px;
			font-size: 16px;
			font-weight: 500;
		}
		.message-template{
			height: 110px;
			position: relative;
			padding: 7px 10px;
			font-size: 12px;
			line-height: 15px;
			overflow-y: hidden;
			border: 1px solid #e2e2e2; 
			margin: 6px 10px;
			border-radius: 12px;
			background-color: #ffffff;
			transition: all 0.3s ease;
			&.expand{
				height: auto;
				.message-value{
					height: auto;
					display: block;
				}
			}
			.message-value{
				height: 75px;
				overflow: hidden;
				-webkit-line-clamp: 5;
				display: -webkit-box;
				-webkit-box-orient: vertical;
			}
			.message-action{
				display: flex;
				flex-direction: row-reverse;
				justify-content: space-between
			}
			.select-button{
				display: none;
			}
			.expand-icon{
				cursor: pointer;
				padding: 5px;
				transition: transform 0.3s ease;
			}
			.expand-icon:hover{
				color: #333333;
				font-weight: bold;
			}
			.expanded-icon{
				transform: rotate(180deg)
			}
		}
		.message-template:hover{
			border: 1px solid #2d3e4f;
			background-color: #f0f7ff;
			.select-button{
				display: inline-block;
				font-size: 10px;
				padding: 3px;
				background-color: #2d3e4f;
				color: #ffffff;
			}
		}
	}
}
</style>

<style scoped>
.message-dialog >>> .el-dialog__body {
	padding: 0px;
}
.message-dialog >>> .el-dialog__header {
	background-color: #2d3e4f;
	padding: 10px 20px 10px;
}
.message-dialog >>> .el-dialog__title {
	color: #ffffff;
	font-size: 14px;
}
.message-dialog >>> .el-dialog__headerbtn {
	top: 12px;
}
.message-dialog >>> .el-dialog__close:hover {
	font-weight: bold;
}
.message-dialog >>> .el-dialog__close {
	color: #ffffff;
	font-size: 20px;
}
.message-dialog >>> .el-dialog__headerbtn:hover .el-dialog__close {
	color: #ffffff;
}
</style>
